<div class="wrapper" [attr.data-size]="size" [attr.data-is-fit-with-small-screen]="isFitWithSmallScreen">
  <ng-content></ng-content>
</div>
